import React, { useState } from 'react';

const AuthorSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const fullBio = `Fred Lynch is a creative communicator, author, and Christian Hip Hop pioneer. 
    Founding P.I.D. (Preachers in Disguise) at 18, he recorded six albums and authored 
    The Script (the Gospel of John in rap). He co-produced Mic Drop, the first documentary 
    on Christian Hip Hop. As a speaker, artist, and trainer, he fosters safer, more connected 
    learning environments, making the sacred positively contagious through words and performance.`;

  const truncatedBio = fullBio.split('.')[0] + '.';

  return (
    <div className="bg-white rounded-lg shadow-sm w-full">
      <div className="p-6">
        <div className="flex items-start space-x-4 mb-6">
          <div className="flex-shrink-0">
            <img 
              src="/fredheadshotv2.png"
              alt="Fred Lynch"
              className="w-16 h-16 rounded-full object-cover"
            />
          </div>
          
          <div>
            <h2 className="text-xl font-semibold text-gray-900">About the Author</h2>
            <p className="text-gray-600">
              Fred Lynch
            </p>
          </div>
        </div>

        {/* Author Bio */}
        <div className="prose max-w-none">
          <p className="text-gray-700 italic">
            {isExpanded ? fullBio : truncatedBio}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-blue-600 hover:text-blue-800 font-medium ml-2 not-italic"
            >
              {isExpanded ? 'Read Less' : 'Read More'}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthorSection;